import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=64ae2ffd&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('64ae2ffd', component.options)
    } else {
      api.reload('64ae2ffd', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=64ae2ffd&", function () {
      api.rerender('64ae2ffd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/components/pagination.vue"
export default component.exports